import { badges } from './badges'
import { composition } from './composition'
import { feedingRecommendation } from './feeding-recommendation'
import { size } from './size'
import { technicalDetails } from './technical-details'
import { Attributes, Properties } from '@rdss/client'

/**
 * Maps the attribute information from the Shopware attributes into a usable structure.
 *
 * @example
 * const {awards} = select(attributes)
 */
export const select = (attributes: Attributes, translation: {[key: string]: string}) => ({
    composition: composition(attributes, translation),
    feedingRecommendation: feedingRecommendation(attributes),
    size: size(attributes, translation),
    technicalDetails: technicalDetails(attributes),
})

/**
 * Maps the attribute and property information from the Shopware product into a usable structure.
 *
 * @example
 * const {badges} = productSelect(attributes, properties)
 */
export const productSelect = (
    attributes: Attributes,
    properties: Properties
) => ({
    badges: badges(attributes, properties),
})
